import { JobDetailsPage, JobListPage } from 'jobs/pages';

import { jobDetailsPath, jobListPath } from './routePaths';

export const jobs = {
  path: jobListPath(),
  exact: true,
  isPrivate: true,
  element: <JobListPage />,
};

export const job = {
  path: jobDetailsPath(),
  exact: true,
  isPrivate: true,
  element: <JobDetailsPage />,
};
